/**
 * Global CSS injected once on app mount.
 *
 * PR 1 of Option A. Two responsibilities:
 *
 *  1) `prefers-reduced-motion: reduce` override — users who asked their
 *     OS for reduced motion get every animation stopped instantly.
 *     Covers the keyframes defined in design/components.jsx (tileIn,
 *     fadeUp, slideIn, halo, pulse, shimmer) + any future transitions.
 *     WCAG 2.3.3 compliance.
 *
 *  2) A focus-visible ring baseline that is accessible by default but
 *     does NOT fight our existing per-component focus styles.
 *
 * Nothing else. Zero current-look changes.
 */

let injected = false;

export function installGlobalStyles() {
  if (typeof document === 'undefined') return; // SSR safety
  if (injected) return;
  if (document.getElementById('fc-global-styles-v1')) { injected = true; return; }

  const css = `
    /* --- prefers-reduced-motion override (WCAG 2.3.3) --- */
    @media (prefers-reduced-motion: reduce) {
      *, *::before, *::after {
        animation-duration: 0.001ms !important;
        animation-iteration-count: 1 !important;
        transition-duration: 0.001ms !important;
        scroll-behavior: auto !important;
      }
    }

    /* --- keyboard focus ring baseline --- */
    :root {
      --fc-focus-ring: 0 0 0 3px rgba(255, 138, 28, 0.35);
    }
    :focus-visible {
      outline: 2px solid rgba(255, 138, 28, 0.65);
      outline-offset: 2px;
      border-radius: 4px;
    }
    /* Remove the outline only where a component has its own ring */
    [data-focus-ring="custom"]:focus-visible {
      outline: none;
    }
  `;

  const style = document.createElement('style');
  style.id = 'fc-global-styles-v1';
  style.textContent = css;
  document.head.appendChild(style);
  injected = true;
}
